import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';
import { openrtbAdverStatistics } from 'lib/api/openrtb';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
let initParam = {
  page: 1,
};

const AdverStatistics = ({ displayFilterList, location }) => {
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const { statsHh } = queryString.parse(location.search);
  initParam = {
    ...initParam,
    statsHh: statsHh,
  };

  const { t } = useTranslation();
  const dispatch = useDispatch();

  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const customized = {
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CLICK_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const clickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        const showWindowUrl =
          '/report/openrtb/adver?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&uri=/report/adver/statistics&isPop=1';
        let resultComponent = (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['CLICK_CNT'],
              clickCnt.type,
              clickCnt.format
            )}
            icon={
              rowObj['STATS_DTTM'] !== 'total' &&
              !rowObj.isChild &&
              'faExternalLink'
            }
            toolTipTitle={t('해당 RTB의 광고주별 통계')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );

        return resultComponent;
      },
    },
  };

  //   const childColumnSet = {
  //     STATS_DTTM: () => {
  //       return null;
  //     },
  //     ADVER_CNT: () => {
  //       return null;
  //     },
  //   };

  /**
   * 테이블 클릭 후 세부정보 받아올때 보낼 param setting 해주는 함수
   * @param {json} data 테이블 로우 데이터
   */
  //   const makeSubParam = (data) => {
  //     return {
  //       statsHh: data.STATS_HH,
  //     };
  //   };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          toolTip={'매 30분 간격으로 데이터가 저장됩니다. (5분/35분)'}
          displayFilterList={displayFilterList}
          useTimeFilter={{ used: true, useRange: false }}
          externalUseRtb
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={openrtbAdverStatistics}
            // dataDetailReqPromise={openrtbAdverStatisticsDetail}
            params={{ ...params }}
            sort="desc"
            order="ADVRTS_AMT"
            dense={true}
            hasExcel
            hasTotal
            // expandTable
            // makeSubParam={makeSubParam}
            // childColumnSet={childColumnSet}
            customized={customized}
            noneSearch
          />
        </>
      )}
    </>
  );
};

export default withRouter(AdverStatistics);
